export const TABS_VALUE_MAP = {
  1: 'bikeOnly',
  2: 'selfDrive',
  3: 'guided',
};
export const SELF_DRIVE_TOUR = 'Self-Drive';
